export default "__VITE_ASSET__CnxMS$hD__"